import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { TopbarRoutes } from './topbar.routes';
import { TopbarComponent } from './topbar.component';
import { HelpModalComponent } from '../../modals/help-modal/help-modal.component';

@NgModule({
  declarations: [
    TopbarComponent,
    HelpModalComponent,
  ],
  exports: [
    TopbarComponent
  ],
  imports: [
    RouterModule.forChild(TopbarRoutes),
    CommonModule,
    FormsModule,
    IonicModule,
  ]
})
export class TopbarModule {}
